
// src/widgets/SpecialMessageWidget.tsx

/**
 * A widget for displaying a special, triggered message.
 */
export function SpecialMessageWidget(): HTMLElement {
    const content = document.createElement('div');
    content.className = 'widget-content';

    content.innerHTML = `<p>You always sink a 3 on the 2nd roll of the 3rd round!</p>`;

    return content;
}
